export default class SimpleAccordion {
  constructor(elem) {
    this.elem = elem;
    this.trigger = elem.querySelector('.js-simple-accordion-trigger');
    this.content = elem.querySelector('.js-simple-accordion-content');

    if (!this.trigger || !this.content) {
      return;
    }

    const { initialized } = elem.dataset;

    if (!initialized) {
      this.elem.setAttribute('data-initialized', true);
      this.trigger.addEventListener('click', () => this.handleClick());
      this.initializeState();
    }
  }

  initializeState() {
    const computedStyle = window.getComputedStyle(this.content);
    const isVisible = computedStyle.display !== 'none';

    if (isVisible) {
      this.trigger.classList.add('is--active');
    } else {
      this.trigger.classList.remove('is--active');
    }
  }

  handleClick() {
    const computedStyle = window.getComputedStyle(this.content);
    const isVisible = computedStyle.display !== 'none';

    if (isVisible) {
      this.content.style.display = 'none';
      this.trigger.classList.remove('is--active');
    } else {
      this.content.style.display = 'block';
      this.trigger.classList.add('is--active');
    }
  }
}
